import React from 'react';
import { motion } from 'framer-motion';
import { Package, Clock, Flag, Palette, ShieldCheck, Headphones } from 'lucide-react';
const features = [{
  icon: Package,
  title: 'Low Minimums',
  description: 'Start with as few as 25 units. Test new designs without large inventory commitments.',
  color: 'bg-blue-500'
}, {
  icon: Clock,
  title: 'Fast Turnaround',
  description: 'Quick production times so you never miss a holiday rush or exhibition opening.',
  color: 'bg-emerald-500'
}, {
  icon: Flag,
  title: 'Made in USA',
  description: 'All products manufactured in Massachusetts. No tariffs, no delays, no customs.',
  color: 'bg-red-500'
}, {
  icon: Palette,
  title: 'Free Design Services',
  description: 'Our art team adapts your assets for products. Digital proofs at no charge.',
  color: 'bg-violet-500'
}, {
  icon: ShieldCheck,
  title: 'Quality Guarantee',
  description: 'Museum-grade quality control. Not perfect? We replace it at no cost.',
  color: 'bg-amber-500'
}, {
  icon: Headphones,
  title: 'Dedicated Support',
  description: 'Personal account managers who understand the museum retail landscape.',
  color: 'bg-pink-500'
}];
export function WhyPartner() {
  return <section className="py-24 bg-white" data-id="element-283">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-284">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-285">
          <h2 className="text-4xl md:text-5xl font-serif font-bold text-museum-black mb-6 tracking-tight" data-id="element-286">
            Why Partner With Us
          </h2>
          <p className="text-xl text-museum-subtle leading-relaxed" data-id="element-287">
            We've built our entire operation around the unique needs of museum
            stores and cultural institutions.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-288">
          {features.map((feature, index) => <motion.div key={feature.title} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1,
          duration: 0.5
        }} className="bg-museum-gray p-8 rounded-2xl hover:shadow-lg transition-shadow duration-300" data-id="element-289">
              <div className={`w-12 h-12 ${feature.color} rounded-xl flex items-center justify-center mb-6`} data-id="element-290">
                <feature.icon className="w-6 h-6 text-white" data-id="element-291" />
              </div>

              <h3 className="text-xl font-serif font-bold text-museum-black mb-3" data-id="element-292">
                {feature.title}
              </h3>

              <p className="text-museum-subtle leading-relaxed" data-id="element-293">
                {feature.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}